import React, { useState, useEffect } from "react";
import { ProposalTopics } from "./ProposalTopics.jsx";
import { ProposalList } from "./ProposalList.jsx";

export function ProposalsByTopic({ configuration }) {
  const [proposalset, setProposalset] = useState({
    topics: [],
    proposal_set: [],
    answeredProposals: [],
  });
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProposalSet();
  }, []);

  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  };

  const getProposalSet = async () => {
    fetch(`/api/v1/proposals/${configuration.proposalsetId}/`, {
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        setProposalset(data);
        setProposals(data.proposal_set);
        setLoading(false);
        console.log("Data proposal", data)
      });
  };

  function loadProposals(topic_id) {
    let proposals;
    if (topic_id == "-1") {
      proposals = proposalset.proposal_set;
    } else if (topic_id) {
      proposals = proposalset.proposal_set.filter((proposal) =>
        proposal.topic_ids.includes(Number(topic_id))
      );
    } else {
      proposals = proposalset.proposal_set.filter(
        (proposal) => proposal.topic_ids.length == 0
      );
    }
    setProposals(proposals);
  }

  let out;
  if (loading) {
    out = (
      <div className="vertical-center w-100 " style={{ minHeight: "400px" }}>
        <div className="spinner-border text-primary " role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  } else if (proposalset.proposal_set.length > 0) {
    out = (
      <div className="proposals-by-topic">
        <ProposalTopics
          proposals={proposals} 
          topics={proposalset.topics}
          loadProposals={loadProposals}
          configuration={configuration}
        />
        <ProposalList
          proposals={proposals}
          configuration={configuration}
        />
      </div>
    );
  } else {
    out = "";
  }
  return out;
}
